// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"AddPurchaseInvoicePosition_modalContainer__3yz2-","inputBox":"AddPurchaseInvoicePosition_inputBox___Fnms","input":"AddPurchaseInvoicePosition_input__3eLUd"};